import { Post } from '../helpers';

const PostToGreenroomSocket = <T = unknown>({
  channel,
  type,
  message,
}: {
  channel: string;
  type: string;
  message: T;
}) => {
  return Post({
    host: import.meta.env.VITE_GREENROOM_API,
    path: '/v2/greenroom/platform-to-greenroom-socket',
    includeBlToken: true,
    includeIdToken: true,
    headers: {
      'bl-global-resource': 'false',
    },
    body: { channel, type, message },
  });
};

export default PostToGreenroomSocket;
